import { post, postJson, get, deleteApi, put } from './axios2'
 
const RESOURCE_BASE_PATH = '/paradiseAndTaskCommon';

const RESOURCE_BASE_PATH1 = '/login';

/* 积分任务 */

// 忠诚度登录
export const loginController = p => get(`${RESOURCE_BASE_PATH1}`, p);

// 积分任务和积分乐园活动公共接口
export const queryActivity = p => postJson(`${RESOURCE_BASE_PATH}/list`, p);

//结束活动
export const endEvent = id => put(`${RESOURCE_BASE_PATH}/${id}`);

//删除活动
export const deleteEvent = id => deleteApi(`${RESOURCE_BASE_PATH}/${id}`);


 
   



// // 查询标签
// export const getBuyerLabelByLabelName = p => get(`${RESOURCE_BASE_PATH1}/page`, p);
// // 添加标签
// export const addBuyerLabel = p => postJson(`${RESOURCE_BASE_PATH1}/`, p);
// //删除标签
// export const deleteLabelById = id => deleteApi(`${RESOURCE_BASE_PATH1}/${id}`);
// // 修改
// export const updateLabelNameById = p => put(`${RESOURCE_BASE_PATH1}/`, p);
// // 删除/批量删除标签
// export const deleteBuyerLabelById = p => post(`${RESOURCE_BASE_PATH}/deleteBuyerLabelById`, p);
// // 修改标签
// export const updateBuyerLabelNameById = p => post(`${RESOURCE_BASE_PATH}/updateBuyerLabelNameById`, p);
// // 标签管理提示
// export const getHintBuyerLabel = p => post(`${RESOURCE_BASE_PATH}/getHintBuyerLabel`, p);
// // 根据回传会员ID集, 查询公共标签
// export const getRetainLabelIds = p => post(`${RESOURCE_BASE_PATH}/getRetainLabelIds`, p);

